import { render } from "./CustomerSer.vue?vue&type=template&id=3eceb521&scoped=true"
import script from "./CustomerSer.vue?vue&type=script&lang=js"
export * from "./CustomerSer.vue?vue&type=script&lang=js"

import "./CustomerSer.vue?vue&type=style&index=0&id=3eceb521&lang=less&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-3eceb521"]])

export default __exports__